import { useDispatch } from 'react-redux';
import { updateUserSettings } from 'redux/users/actions';
import { IUserSettings } from 'redux/users/types';

export const useUserSettings = () => {
    const dispatch = useDispatch();
    
    const updateSettings = (newSettings: Partial<IUserSettings>, silent = false) => {
        // @ts-ignore
        dispatch(updateUserSettings(newSettings, silent))
    };
    
    return {
        updateSettings,
    };
};